import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VAutocomplete,{attrs:{"items":_vm.facilities,"item-value":_vm.resolvedItemValue,"item-text":_vm.itemText,"label":_vm.label,"multiple":_vm.multiple,"chips":_vm.chips,"dense":_vm.dense,"outlined":_vm.outlined,"clearable":_vm.clearable,"rules":_vm.rules,"hint":_vm.localValue,"persistent-hint":true},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }